import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export interface ToastConfig {
  severity: 'error' | 'success' | 'warn' | 'info';
  summary: string;
  detail: string;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  constructor() {
    console.log('NotificationService - Inicializado:', !!this.messageService);
  }

  private translateOrDefault(key: string, fallback: string): string {
    const translated = this.translate.instant(key);
    return translated !== key ? translated : fallback;
  }

  showError(message: string, summary?: string): void {
    try {
      this.messageService.add({
        severity: 'error',
        summary: summary || this.translateOrDefault('notifications.summary.error', 'Error'),
        detail: message,
        life: 6000,
        closable: true,
      });
    } catch (error) {
      console.error('❌ Error en MessageService.add:', error);
    }
  }

  showSuccess(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'success',
      summary: summary || this.translateOrDefault('notifications.summary.success', 'Success'),
      detail: message,
      life: 4000,
      closable: true,
    });
  }

  showWarning(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'warn',
      summary: summary || this.translateOrDefault('notifications.summary.warning', 'Warning'),
      detail: message,
      life: 5000,
      closable: true,
    });
  }

  showInfo(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'info',
      summary: summary || this.translateOrDefault('notifications.summary.info', 'Info'),
      detail: message,
      life: 3000,
      closable: true,
    });
  }
}
